import * as Sentry from "@sentry/react";
import { store } from "../redux/store";
import axiosInstance from "./axiosConfig";
import { lawyerSelectors } from "../redux/lawyer/selectors";

export const getAvailableCredits = async (): Promise<number> => {
  try {
    const state = store.getState();
    const lawyerId = lawyerSelectors.selectUid(state);

    if (!lawyerId) {
      throw new Error("No lawyer ID found");
    }

    const response = await axiosInstance.get("/credits/available", {
      params: {
        lawyerId
      }
    });
    return response.data.credits;
  } catch (error) {
    Sentry.captureException(error);
    return 0;
  }
};
